import { Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { PriestProvider } from "./lib/auth";
import PriestLayout from "./components/PriestLayout";
import PriestLogin from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Requests from "./pages/Requests";
import Availability from "./pages/Availability";
import Profile from "./pages/Profile";
import Messages from "./pages/Messages";

export default function PriestApp() {
  return (
    <PriestProvider>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="login" element={<PriestLogin />} />
        <Route element={<PriestLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="requests" element={<Requests />} />
          <Route path="messages" element={<Messages />} />
          <Route path="availability" element={<Availability />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
    </PriestProvider>
  );
}
